<script lang="ts">import SvgIcon from "./SvgIcon.svelte";
</script>

<SvgIcon>
  <svg
    width="83%"
    height="83%"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="28.7778" height="28" rx="14" fill="white" />
    <path
      d="M12.8763 19.6253C12.73 19.6253 12.5894 19.569 12.4769 19.4621L9.47313 16.4584C9.25375 16.239 9.25375 15.8846 9.47313 15.6653C9.6925 15.4459 10.0469 15.4459 10.2663 15.6653L13.27 18.669C13.4894 18.8884 13.4894 19.2428 13.27 19.4621C13.1688 19.569 13.0225 19.6253 12.8763 19.6253Z"
      fill="#8D5FFF"
    />
    <path
      d="M20.1881 14.5627H7.81308C7.58808 14.5627 7.37995 14.4277 7.29558 14.2139C7.2112 14.0058 7.2562 13.7639 7.41933 13.6008L12.4818 8.53831C12.7012 8.31894 13.0556 8.31894 13.275 8.53831C13.4943 8.75769 13.4943 9.11206 13.275 9.33144L9.1687 13.4377H20.1881C20.4974 13.4377 20.7506 13.6908 20.7506 14.0002C20.7506 14.3096 20.4974 14.5627 20.1881 14.5627Z"
      fill="#8D5FFF"
    />
  </svg>
</SvgIcon>
